var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bpm-editor-container"},[_c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":_vm.bpmEditorUrl,"frameborder":"no","border":"0","marginwidth":"0","marginheight":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }